import { StyleSheet, View } from 'react-native';

import { colors, radii, spacing } from '@/constants/theme';

export type PageDotsProps = {
  count: number;
  /** The page in view, 0-based. */
  active: number;
  testID?: string;
};

/**
 * Where a sideways row is scrolled to (Figma "Story n of m"): a Deep Green
 * pill for the page in view, small dots for the rest. Read-only; the row
 * itself is what scrolls.
 */
export function PageDots({ count, active, testID }: PageDotsProps) {
  if (count < 2) return null;
  return (
    <View
      style={styles.row}
      accessible
      accessibilityLabel={`${active + 1} of ${count}`}
      testID={testID}
    >
      {Array.from({ length: count }, (_, i) => (
        <View key={i} style={[styles.dot, i === active && styles.active]} />
      ))}
    </View>
  );
}

const DOT = 7;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.xs,
    minHeight: 44,
  },
  dot: {
    width: DOT,
    height: DOT,
    borderRadius: radii.full,
    backgroundColor: colors.trackMutedFill,
  },
  active: {
    width: 18,
    backgroundColor: colors.deepGreen,
  },
});
